<template>
  <div class="entity-list" v-loading="loading">
    <div class="button-group">
      <div class="filling"></div>
      <el-input
        class="filter-input2"
        size="small"
        clearable
        placeholder="请输入列名"
        v-model="filterValue"
        @keyup.enter.native="listFilter"
        @clear="listFilter"
      >
        <i
          class="el-icon-search el-input__icon"
          slot="suffix"
          @click="listFilter"
        ></i>
      </el-input>

      <el-button size="small" type="primary" @click="addEntity">
        添 加
      </el-button>
    </div>
    <!-- table -->
    <el-table :data="tableData" height="calc(100% - 72px)">
      <el-table-column label="名称" #default="{row}" min-width="120">
        <div class="path" @click="$emit('entityClick', row)">
          {{ row.name }}
        </div>
      </el-table-column>
      <el-table-column
        label="编码"
        prop="code"
        min-width="100"
      ></el-table-column>
      <el-table-column
        label="数据表"
        prop="datalist"
        min-width="300"
        #default="{row}"
      >
        {{ row.dsName }}.{{ row.dbName }}.{{ row.tableName }}
      </el-table-column>
      <el-table-column
        label="创建者"
        prop="creator"
        min-width="100"
      ></el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        min-width="180"
      ></el-table-column>
      <el-table-column
        label="修改时间"
        prop="updateTime"
        min-width="180"
      ></el-table-column>
      <el-table-column
        label="描述"
        prop="description"
        min-width="220"
      ></el-table-column>
      <el-table-column label="操作" width="90" #default="{row}">
        <i class="icon-button el-icon-ga-bianji" @click="entityConfig(row)"></i>
        <i
          class="icon-button el-icon-ga-shanchu"
          @click="entityDelete(row)"
        ></i>
      </el-table-column>
    </el-table>

    <page-trun
      :disabled="loading"
      :fixed="true"
      :page="page"
      :queryData="queryData"
      @pageTrun="pageTrun"
    />
    <!-- dialog -->
    <create-entity
      :dialog.sync="dialog"
      :propData="propData"
      @refush="refush"
    />
  </div>
</template>

<script>
import CreateEntity from "./createEntity.vue";
import { Delete } from "@/utils";
export default {
  name: "EntityList",
  components: {
    CreateEntity
  },
  data() {
    return {
      dialog: false,
      loading: false,
      page: {
        pageIndex: 1,
        hasMore: false
      },
      propData: {},
      queryData: {},
      filterValue: "",
      searchValue: ""
    };
  },
  computed: {
    tableData() {
      return this.queryData[this.page.pageIndex];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .get(
          `/gavial/v1/di/list?keyWord=${this.searchValue}&pageIndex=${this.page.pageIndex}&pageSize=20`
        )
        .then(res => {
          this.$set(this.queryData, res.data.pageIndex, res.data.data);
          this.page.pageIndex = res.data.pageIndex;
          this.page.hasMore = res.data.hasMore;
        });
    },
    addEntity() {
      this.propData = {};
      this.dialog = true;
    },
    listFilter() {
      this.searchValue = this.filterValue;
      this.page = {
        pageIndex: 1,
        hasMore: false
      };
      this.queryData = {};
      this.getData();
    },
    entityConfig(row) {
      this.loading = true;
      this.$http
        .get(`/gavial/v1/di/edit/pre?id=${row.id}`)
        .then(res => {
          this.propData = res.data.data;
          this.dialog = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    entityDelete(row) {
      Delete(`/gavial/v1/di/del?id=${row.id}`, row.name, () => {
        this.getData();
        this.$emit("entityDelete", row.name);
      });
    },
    pageTrun(i) {
      this.page.pageIndex = i;
      if (!this.queryData[this.page.pageIndex]) {
        this.getData();
      }
    },
    refush() {
      // 清除过滤刷新
      this.filterValue = "";
      this.listFilter();
    }
  }
};
</script>

<style lang="scss" scoped>
.entity-list {
  height: 100%;
  .filter-input2 {
    width: 230px;
    margin-right: var(--padding);
    .el-icon-search {
      cursor: pointer;
      &:hover {
        color: var(--blue);
      }
    }
  }
  .icon-button {
    font-size: 20px;
    &.el-icon-ga-shanchu:hover {
      color: var(--red);
    }
  }
}
</style>
